<template>
  <div>
    <search-agent-transfers @submit="submitSearch" />

    <div class="iotplt-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchAgentTransfers from '@/views/transfers/top_agent_self/Search'
import { findAgentTransfers, exportAgentTransfers } from '@/api/transfer'
import { formatCurrency } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'AgentTransferList',
  components: {
    SearchAgentTransfers,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {
      }
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }

      return this.$store.getters.userAgentId
    },

    columns() {
      return [
        {
          title: '事件批次',
          width: 100,
          dataIndex: 'no'
        },
        {
          title: '收付款日期',
          width: 120,
          dataIndex: 'paid_at'
        },
        {
          title: '收付款类型',
          width: 100,
          dataIndex: 'transfer_type'
        },
        {
          title: '金额(元)',
          width: 100,
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '支付方式',
          width: 100,
          dataIndex: 'pay_way'
        },
        {
          title: '记录人',
          width: 100,
          dataIndex: 'operator_name'
        },
        {
          title: '记录时间',
          width: 180,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentTransfers(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    exportData() {
      exportAgentTransfers(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

